<template>
  <div>
    <h1 class="align-center">Add new image set</h1>
    <create-form :save="create"></create-form>
  </div>
</template>

<script>
import CreateForm from './Form';
import imageSetApi from './../../../../api/image-set';

export default {
  components: {
    'create-form': CreateForm,
  },
  methods: {
    create(form) {
      imageSetApi.store(form).then((imageSet) => {
        toastr.success('Created successfully');

        setTimeout(() => {
          this.$router.push({
            name: 'portfolio.collection.add-images',
            params: {id: imageSet.id},
          });
        }, 2000);
      });
    },
  }
};
</script>